import { motion } from "framer-motion";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Grid, Row } from "react-flexbox-grid";

import ImageParagraph from "../../paragraphs/ImageParagraph";
import * as styles from "./styles.module.css";

const BlueBoxImage = ({ image, alt, children, left = false, imageData }) => {
  // TODO: need to reformat after all images are pulling from drupal
  const Image = imageData ? (
    <ImageParagraph content={imageData} />
  ) : (
    <GatsbyImage image={getImage(image)} alt={alt} />
  );

  return (
    <div className={styles.container}>
      <Grid>
        <Row className={`${left ? styles.reverse : null} align-center`}>
          <Col xs={12} md={6} lg={8}>
            <motion.div
              initial={{ scale: 1, x: 120, opacity: 0 }}
              whileInView={{ scale: 1.1, x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              {Image}
            </motion.div>
          </Col>
          <Col xs={12} md={6} lg={4}>
            <motion.div
              initial={{ x: -120, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className={styles.bluebox}
            >
              {children}
            </motion.div>
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default BlueBoxImage;
